import { OrderItemRowResolver } from './types'

export const labelOrderItemRowResolver: OrderItemRowResolver = item => {
    const position = item.shipment_position
    const shipment = position?.shipment
    const totalCopies = shipment?.shipment_positions?.reduce((sum, p) => sum + (p.copies ?? 0), 0)
    const turnover = shipment?.calculated?.turnover

    const price =
        position?.copies != null && turnover != null && totalCopies
            ? (turnover / totalCopies) * position.copies
            : undefined

    return {
        name: position?.labelName ?? item.name,
        quantity: position?.copies ?? item.quantity,
        price,
    }
}
